import { theme as baseTheme, ITheme } from '@chakra-ui/core';
import merge from 'lodash/merge';

import overrides from './overrides';

const theme: ITheme = merge(baseTheme, overrides);

export default theme;
